import { render, staticRenderFns } from "./Screenings.vue?vue&type=template&id=c26b8850&scoped=true&"
import script from "./Screenings.vue?vue&type=script&lang=js&"
export * from "./Screenings.vue?vue&type=script&lang=js&"
import style0 from "./Screenings.vue?vue&type=style&index=0&id=c26b8850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26b8850",
  null
  
)

export default component.exports